import React, { useState } from "react";
import { svgIcons } from "../../../../style/fonts/SvgIcons";
import DateComp from "../../../../core/common/dateComponent/DateComp";

interface Folder {
  folderId: number;
  entityName: string;
  parentId: number | null;
  isFile: boolean;
  children: Folder[];
  isLocked: number
}

const FolderListView = React.memo(({ folders, viewFilePerm, editFilePerm, setIsFile, setSelectedRowId, setSelectedParentId, setSelectedFolderName }: any) => {
  const [selectedFolderPath, setSelectedFolderPath] = useState<string | null>(null);

  const handleFolderSelection = (path: string, folderId: any, parentId: any, folderName: any, isLocked: boolean, isFile: any) => {
    if (isLocked) return;
    setSelectedFolderPath(path);
    setSelectedRowId(folderId)
    setSelectedFolderName(folderName)
    setSelectedParentId(parentId)
    setIsFile(isFile)
  };

  const flattenFolders = (folder: Folder, parentPath: string = "", parentLocked: boolean = false): any[] => {
    const currentPath = parentPath ? `${parentPath}` : `${folder.folderId}`;
    const isFolderLocked = parentLocked || folder.isLocked === 1;
    const flattened = [{ ...folder, path: currentPath, isLocked: isFolderLocked }];

    if (!folder.isFile && folder.children.length > 0) {
      folder.children.forEach((child, index) => {
        const childPath = parentPath ? `${currentPath}.${index + 1}` : `${folder.folderId}.${index + 1}`;
        flattened.push(...flattenFolders(child, childPath, isFolderLocked));
      });
    }
    return flattened;
  };

  const flattenedFolders = folders?.result
    ?.map((folder: Folder, index: number) => flattenFolders(folder, `${index + 1}`))
    .flat() || [];

  return (
    <div className="table-responsive mt-3" style={{ maxHeight: '540px' }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#f0f0f0", textAlign: "left" }}>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>File/Folder Name</th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Type</th>
            {/* <th style={{ border: "1px solid #ddd", padding: "8px" }}>Created</th> */}
          </tr>
        </thead>
        <tbody>
          {flattenedFolders.map((folder: any) => (
            <tr
              key={folder.folderId}

              style={{
                backgroundColor: selectedFolderPath === folder.path ? "#e6f7ff" : "transparent",
                cursor: "pointer",
                opacity: folder.isLocked ? 0.5 : 1,
              }}
              onClick={() => handleFolderSelection(folder.path, folder.folderId, folder.parentId, folder.entityName, folder.isLocked, folder.isFile)}
            >
              <td style={{ border: "1px solid #ddd", padding: "8px" }} className="d-flex justify-content-between align-items-center">
                {folder.isFile ?
                  <p
                    className="mb-0"
                  >
                    {`${folder.entityName}`}
                  </p>
                  :
                  <>
                    {folder.entityName}
                  </>
                }
                <div className="d-flex gap-3">
                  {folder.isFile && folder.localPath !== null ? (
                    <>
                      {editFilePerm &&
                        <button className="btn btn-primary p-1">
                          <a
                            href={folder.localPath}
                            target="_blank"
                            className="text-light fs-12"
                            rel="noopener noreferrer"
                            download
                          >
                            {/* {`${folder.entityName}`} */}
                            Edit File
                          </a>
                        </button>
                      }
                    </>
                  ) :
                    (
                      ""
                    )

                  }

                  {folder.isFile ? (
                    <>
                      {viewFilePerm &&
                        <button className="btn btn-primary p-1">
                          <a
                            href={folder.entityPath}
                            target="_blank"
                            className="text-light fs-12"
                            rel="noopener noreferrer"
                            download
                          >
                            {/* {`${folder.entityName}`} */}
                            View File
                          </a>
                        </button>
                      }
                    </>
                  ) :
                    (
                      ""
                    )

                  }

                </div>
                {/* {folder.path}-{folder.entityName} */}
                {/* {folder.isLocked &&
                          <span className="ms-4">{svgIcons?.LockIcon}</span>
                        } */}
              </td>
              <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                {folder.isFile ? "File" : "Folder"}
              </td>
              {/* <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                <DateComp formattedDate={folder.createdDate} />
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div >
  );
});

export default FolderListView;
